import Vue from "vue"
import VueRouter from "vue-router"

import moment from "@/utils/moment"
import numeral from "@/utils/numeral"

import App from "./app.vue"
import router from "./router"
import store from "./store"
import errorHandler from "./services/error-handler"
import { AppBrowser, clearSpecialChars, cloneObject, formatCgc, Message, reloadDataTables, replaceAll, truncateString } from "./utils"

Vue.config.productionTip = false

Vue.prototype.$cloneObject = cloneObject
Vue.prototype.$errorHandler = errorHandler
Vue.prototype.$formatCgc = formatCgc
Vue.prototype.$msg = Message
Vue.prototype.$reloadDataTables = reloadDataTables
Vue.prototype.$replaceAll = replaceAll
Vue.prototype.$truncateString = truncateString

Vue.prototype.$historyBack = () => { window.history.back() }
Vue.prototype.$isMobile = AppBrowser.isMobile()
Vue.prototype.$isDesktop = AppBrowser.isDesktop()

Vue.prototype.$isDevelopment = (process.env.VUE_APP_ENV == "development")
Vue.prototype.$isStaging = (process.env.VUE_APP_ENV == "staging")
Vue.prototype.$isProduction = (process.env.VUE_APP_ENV == "production")

Vue.prototype.$formatDate = (date) => date && date.trim() ? moment(date).format("DD/MM/YYYY") : ""
Vue.prototype.$formatTime = (date) => date && date.trim() ? moment(date).format("HH:mm") : ""
Vue.prototype.$formatInteger = (value) => numeral(value).format("0,0")
Vue.prototype.$formatCurrency = (value) => numeral(value).format("0,0.00")
Vue.prototype.$formatCurrencyWith4Decimals = (value) => numeral(value).format("0,0.0000")

Vue.prototype.$isAdmin = () => (store.state.auth.user && store.state.auth.user.group == "admin")
Vue.prototype.$isEmployee = () => (store.state.auth.user && store.state.auth.user.group == "employee")
Vue.prototype.$isFinancial = () => (store.state.auth.user && store.state.auth.user.group == "financial")
Vue.prototype.$isSimavet = () => (store.state.auth.user && (store.state.auth.user.group == "admin" || store.state.auth.user.group == "employee" || store.state.auth.user.group == "financial"))
Vue.prototype.$isCustomer = () => (store.state.auth.user && store.state.auth.user.group == "customer")
Vue.prototype.$isVet = () => (store.state.auth.user && store.state.auth.user.group == "vet")

Vue.prototype.$toUpperCase = ($event) => $event.target.value.toUpperCase().trim()
Vue.prototype.$clearEmail = ($event) => clearSpecialChars($event.target.value.trim())

Vue.use(VueRouter)

new Vue({
  router,
  store,
  render: (createElement) => createElement(App)
}).$mount("#app")
